/**
 * Registers the PWA service worker in production builds.
 * Required for "Add to Home Screen" / install on mobile and desktop.
 */

export const PWA_UPDATE_EVENT = "pwa-update-available";

let refreshing = false;

function dispatchUpdateAvailable() {
  window.dispatchEvent(new CustomEvent(PWA_UPDATE_EVENT));
}

function notifyIfWaiting(registration) {
  if (registration.waiting && navigator.serviceWorker.controller) {
    dispatchUpdateAvailable();
  }
}

export function applyPwaUpdate() {
  navigator.serviceWorker.getRegistration().then((registration) => {
    if (!registration?.waiting) return;
    refreshing = true;
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  });
}

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!refreshing) return;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/sw.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        notifyIfWaiting(registration);

        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;

          installing.onstatechange = () => {
            if (installing.state !== "installed") return;

            if (navigator.serviceWorker.controller) {
              dispatchUpdateAvailable();
              return;
            }

            installing.postMessage({ type: "SKIP_WAITING" });
          };
        };
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}
